import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type BolexCompletedPayload = {
  bolus_id: number;
  iob?: number;
  bolex_insulin_delivered?: number;
  bolex_insulin_requested?: number;
};

export type BolexCompletedEvent = {
  bolusId: number;
  iob?: number;
  bolexInsulinDelivered?: number;
  bolexInsulinRequested?: number;
};

const bolexCompletedSchema = z.object({
  bolus_id: z.number(),
  iob: cz.permissive(z.number()),
  bolex_insulin_delivered: cz.permissive(z.number()),
  bolex_insulin_requested: cz.permissive(z.number()),
});

export const LID_BOLEX_COMPLETED = {
  value: 0x15,
  name: "Extended Portion of a Bolus Complete Event",
  format: "..hfff",
  fields: ["bolus_id", "iob", "bolex_insulin_delivered", "bolex_insulin_requested"],
  postprocess: rec => ({
    bolusId: rec.bolus_id,
    iob: rec.iob,
    bolexInsulinDelivered: rec.bolex_insulin_delivered,
    bolexInsulinRequested: rec.bolex_insulin_requested,
  }),
  schema: bolexCompletedSchema,
} as const satisfies TandemEventDefinition<BolexCompletedPayload, BolexCompletedEvent>;
